export const over = [
    {
        id: 1,
        name: "Աշխարհագրության ուսուցիչ․ վերապատրաստման ծրագիր 2025",
        info: "Դիտել",
        file:"../../files/geography/over/1.pdf",
        menuItemId: 6
    },

];
